import React from 'react';
import { X } from 'lucide-react';
import AssetFormFields from './AssetFormFields';
import AssetImageUpload from '../../components/AssetImageUpload';

const AssetModal = ({ assetForm, setAssetForm, createAsset, loading, setShowAddAsset, buildings, buildingsLoading, buildingsError }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Add New Asset</h2>
          <button onClick={() => setShowAddAsset(false)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <AssetFormFields
          assetForm={assetForm}
          setAssetForm={setAssetForm}
          buildings={buildings}
          buildingsLoading={buildingsLoading}
          buildingsError={buildingsError}
        />
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Asset Images</label>
          <AssetImageUpload
            images={assetForm.images}
            onImagesChange={imgs => setAssetForm({ ...assetForm, images: imgs })}
            maxImages={5}
            disabled={loading}
          />
          <p className="text-xs text-gray-500 mt-1">Upload up to 5 images to visually document this asset.</p>
        </div>
        <div className="flex gap-3 pt-4">
          <button onClick={() => setShowAddAsset(false)}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">Cancel</button>
          <button onClick={createAsset} disabled={loading}
            className="flex-1 text-white px-4 py-2 rounded-lg hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: "#00C5CB" }}>
            {loading ? "Creating..." : "Create Asset"}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default AssetModal;
